const routes = [
    {
        path: "/student/id/card",
        component: () => import("./Index")
    }
];

export default routes;
